import {
    Block,
    BlockBetween,
    BlockHead,
    BlockHeadContent,
    BlockTitle,
    Button,
    Col,
    DataTable,
    DataTableBody,
    DataTableHead,
    DataTableItem,
    DataTableRow,
    Icon,
    PaginationComponent,
    TooltipComponent,
} from "components/Component";
import Content from "layout/content/Content";
import Head from "layout/head/Head";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { useForm } from "react-hook-form";
import { getPermission } from "utils/Utils";
import {
    Card,
    CardBody,
    Form,
    FormGroup,
    Modal,
    ModalBody
} from "reactstrap";
import {
    serviceDeleteHoliday,
    serviceGetHolidays,
    servicePostHoliday,
    servicePutHoliday,
} from "services/holidays";
import Swal from "sweetalert2";

const Holidays = () => {
  const [data, setData] = useState([]);
  const [onSearchText, setSearchText] = useState("");
  const [currentPage] = useState(1);
  const [itemPerPage] = useState(15);
  const [editContent, setEditContent] = useState(false);
  const [cookies] = useCookies(["user"]);
  const [modal, setModal] = useState({
    detail: false,
    add: false,
  });
  const [metaData, setMetaData] = useState({
    itemCount: 0,
    page: 1,
    take: 0,
    pageCount: 0,
    hasPreviousPage: false,
    hasNextPage: false,
  });

  const [formData, setFormData] = useState({
    id: "",
    name: "",
    date: "",
  });
  const handleDelete = (id) => {
    if(!roleFunctions.includes('delete')){return}
    Swal.fire({
      title: "Are you sure for delete this item?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      reverseButtons: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result)=> {
      if(result.isConfirmed){
        onDeleteSubmit(id);
      }
    })  
  };

  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);
  const [sm, updateSm] = useState(false);
  const roleFunctions = getPermission()['roles']?.access || [];
  // Change Page
  const paginate = (pageNumber) => refreshData(pageNumber);

  const refreshData = async(pageNumber) =>{
    if(!roleFunctions.includes('read')){return}

    const response = await serviceGetHolidays(cookies.SIDikey, onSearchText, pageNumber);
    if (response.status === 200) {
      setMetaData(response.data.meta);
      setData(response.data.data);
    }
  }

  // unselects the data on mount
  useEffect(() => {
    refreshData(1);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    refreshData(1);
  }, [onSearchText]);  // eslint-disable-line react-hooks/exhaustive-deps

  const resetForm = () => {
    setFormData({
        id: "",
        name: "",
        date: "",
    });
  };
  const { errors, register, handleSubmit } = useForm();

  const onDetailClick = (id) => {
    data.forEach((item) => {
      if (item.id === id) {
        setFormData({
          id: item.id,
          name: item.name,
          date: item.date,
          createdAt: item.createdAt,
          createdBy: item.createdBy?.firstName ? item.createdBy.firstName + " " + item.createdBy.lastName : 'System',
          updatedAt: item.updatedAt || '-',
          updatedBy: item.updatedBy?.firstName ? item.updatedBy.firstName + " " + item.updatedBy.lastName : 'System',
        });
        setModal({ detail: true, add: false });
      }
    });
  };
  const onEditClick = (id) => {
    onDetailClick(id);
    setEditContent(true);
  };

  const onFormCancel = () => {
    setModal({ add: false, detail: false });
    setEditContent(false);
    resetForm();
  };

  const onEditSubmit = async (submittedData) => {
    if (!roleFunctions.includes("update")) {
      return;
    }
    console.log(formData.id);
    const response = await servicePutHoliday(formData.id, cookies.SIDikey, submittedData);
    if (response.status === 202) {
      Swal.fire("Edit Holiday", "Berhasil", "success");
      refreshData(currentPage);
      onFormCancel();
    } else {
      Swal.fire("Edit Holiday", "Gagal", "error");
    }
  };

  const onSaveSubmit = async (submittedData) => {
    if (!roleFunctions.includes("create")) {
      return;
    }
    const response = await servicePostHoliday(cookies.SIDikey, submittedData);
    if (response.status === 201) {
      Swal.fire("Add Holiday", "Berhasil", "success");
      refreshData(1);
      onFormCancel();
    } else {
      Swal.fire("Add Holiday", "Gagal", "error");
    }
  };

  const onDeleteSubmit = async (id) => {
    const response = await serviceDeleteHoliday(id, cookies.SIDikey);
    if(/20+/.test(response.status)){
      Swal.fire('Delete Holiday', 'Berhasil', 'success');
      refreshData(currentPage);
    }else{
      Swal.fire('Delete Holiday Failed',response.data.message[0].detail, "error");
    }
  }

  return (
    <React.Fragment>
      <Head title="Holidays"></Head>

      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle tag="h3" page>
                Holidays
              </BlockTitle>
            </BlockHeadContent>
          </BlockBetween>
          <Card className="card-bordered my-4 card-bluesky">
            <CardBody className="card-bluesky-body">
              <strong>Info:</strong>
              <p>This page is used to control the holidays for other pages</p>
            </CardBody>
          </Card>
          <Block className="d-flex justify-content-end">
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <Button
                  className={`btn-icon btn-trigger toggle-expand mr-n1 ${sm ? "active" : ""}`}
                  onClick={() => updateSm(!sm)}
                >
                  <Icon name="menu-alt-r"></Icon>
                </Button>
                <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                  <ul className="nk-block-tools g-3">
                    <li className="nk-block-tools-opt">
                      <Button color="primary" className="btn" onClick={() => setModal({ add: true })}>
                        <i className="ni ni-plus"></i>
                        <span>Tambah Baru</span>
                      </Button>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </Block>
        </BlockHead>
        <Block>
          <DataTable className="card-stretch">
            <div className="card-inner position-relative card-tools-toggle">
              <div className="card-title-group">
                <div className="form-control-wrap w-25">
                  <div className="form-icon form-icon-left">
                    <Icon name="search"></Icon>
                  </div>
                  <input 
                    type="text" 
                    className="form-control w-100" 
                    id="default-04" 
                    placeholder="Search by name" 
                    onInput={(e) => setSearchText(e.target.value)}
                  />
                </div>
              </div>
            </div>
            <DataTableBody>
              <DataTableHead>
                <DataTableRow className="nk-tb-col-check">
                  <span className="sub-text">No</span>
                </DataTableRow>
                <DataTableRow size="md">
                  <span className="sub-text">Name</span>
                </DataTableRow>
                <DataTableRow size="md">
                  <span className="sub-text">Date</span>
                </DataTableRow>
                <DataTableRow size="md">
                  <span className="sub-text">Actions</span>
                </DataTableRow>
              </DataTableHead>
              {/*Head*/}
              {currentItems.length > 0
                ? currentItems.map((item, idx) => {
                    return (
                      <DataTableItem key={item.id}>
                        <DataTableRow size="mb">
                          <span className="tb-amount">{(metaData.page - 1) * metaData.take + (idx + 1)}</span>
                        </DataTableRow>
                        <DataTableRow size="md">
                          <span className="tb-amount">{item.name}</span>
                        </DataTableRow>
                        <DataTableRow size="md">
                          <span className="tb-amount">{moment(item.date).format("DD MMMM YYYY")}</span>
                        </DataTableRow>
                        <DataTableRow noWrap>
                          <ul className="nk-tb-actions table-action">
                            <li className="nk-tb-action" onClick={() => onDetailClick(item.id)}>
                              <TooltipComponent
                                tag="a"
                                containerClassName="btn btn-trigger btn-icon"
                                id={"detail" + item.id}
                                icon="eye-fill"
                                direction="top"
                                text="Detail"
                              />
                            </li>
                            {roleFunctions.includes('update') &&   <li className="nk-tb-action" onClick={() => onEditClick(item.id)}>
                              <TooltipComponent
                                tag="a"
                                containerClassName="btn btn-trigger btn-icon"
                                id={"edit" + item.id}
                                icon="edit-alt-fill"
                                direction="top"
                                text="Edit"
                              />
                            </li>}

                            {roleFunctions.includes('delete') &&  <li className="nk-tb-action" onClick={() => handleDelete(item.id)}>
                              <TooltipComponent
                                tag="a"
                                containerClassName="btn btn-trigger btn-icon"
                                id={"suspend" + item.id}
                                icon="trash-fill"
                                direction="top"
                                text="Hapus"
                              />
                            </li>}
                          </ul>
                        </DataTableRow>
                      </DataTableItem>
                    );
                  })
                : null}
            </DataTableBody>
            <div className="card-inner">
              {currentItems.length > 0 ? (
                <PaginationComponent
                itemPerPage={metaData.take}
                totalItems={metaData.itemCount}
                paginate={paginate}
                currentPage={metaData.page}
                />
              ) : (
                <div className="text-center">
                  <span className="text-silent">No data found</span>
                </div>
              )}
            </div>
          </DataTable>
        </Block>
      </Content>
      {!roleFunctions.includes('create') || 
        <Modal
          isOpen={modal.add}
          backdrop="static"
          keyboard={false}
          toggle={() => setModal({ detail: false })}
          className="modal-dialog-centered"
          size="lg"
        >
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Tambah Holiday</h5>
              <Block className="d-flex justify-content-end"></Block>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onSaveSubmit)}>
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Name</label>
                      <input
                        className="form-control"
                        type="text"
                        name="name"
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.name && <span className="custom-invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="12">
                    <FormGroup>
                      <label className="form-label">Date</label>
                      <input
                        className="form-control"
                        type="date"
                        name="date"
                        ref={register({ required: "This field is required" })}
                      />
                      {errors.date && <span className="custom-invalid">{errors.date.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button
                          outline
                          color="primary"
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                        >
                          Batal
                        </Button>
                      </li>
                      <li>
                        <Button color="primary" size="md" type="submit">
                          Simpan
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
      }

      <Modal
        isOpen={modal.detail}
        backdrop="static"
        keyboard={false}
        toggle={() => setModal({ detail: false })}
        className="modal-dialog-centered"
        size="lg"
      >
        <ModalBody>
          <a
            href="#cancel"
            onClick={(ev) => {
              ev.preventDefault();
              onFormCancel();
            }}
            className="close"
          >
            <Icon name="cross-sm"></Icon>
          </a>
          <div className="p-2">
            <h5 className="title">Detail Holiday</h5>
            <Block className="d-flex justify-content-end"></Block>
            <div className="mt-4">
              <Form className="row gy-4" onSubmit={handleSubmit(onEditSubmit)}>
                <Col md="12">
                  <FormGroup>
                    <label className="form-label">Name</label>
                    <input
                      className="form-control"
                      type="text"
                      name="name"
                      defaultValue={formData.name}
                      disabled={!editContent}
                      ref={register({ required: "This field is required" })}
                    />
                    {errors.name && <span className="custom-invalid">{errors.name.message}</span>}
                  </FormGroup>
                </Col>
                <Col md="12">
                  <FormGroup>
                    <label className="form-label">Date</label>
                    <input
                      className="form-control"
                      type="date"
                      name="date"
                      defaultValue={moment(formData.date).format("YYYY-MM-DD")}
                      disabled={!editContent}
                      ref={register({ required: "This field is required" })}
                    />
                    {errors.date && <span className="custom-invalid">{errors.date.message}</span>}
                  </FormGroup>
                </Col>
                {editContent || <><Col md="6">
                  <FormGroup>
                    <label className="form-label">Created At</label>
                    <input
                      className="form-control"
                      type="text"
                      name="createdAt"
                      value={moment(formData.createdAt).format("MMM DD, YYYY, HH:mm")}
                      disabled={!editContent}
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <label className="form-label">Created By</label>
                    <input
                      className="form-control"
                      type="text"
                      name="createdBy"
                      value={formData.createdBy}
                      disabled={!editContent}
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <label className="form-label">Modified At</label>
                    <input
                      className="form-control"
                      type="text"
                      name="modifiedAt"
                      value={formData.updatedAt === '-' ? '-' : moment(formData.updatedAt).format("MMM DD, YYYY, HH:mm")}
                      disabled={!editContent}
                    />
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup>
                    <label className="form-label">Modified By</label>
                    <input
                      className="form-control"
                      type="text"
                      name="modifiedBy"
                      value={formData.updatedBy}
                      disabled={!editContent}
                    />
                  </FormGroup>
                </Col>
                </>}

                <Col size="12">
                  <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                  {editContent ? (
                    <>
                      <li>
                        <Button
                          outline
                          color="primary"
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                        >
                          Batal
                        </Button>
                      </li>
                      <li>
                        <Button color="primary" size="md" type="submit">
                          Simpan
                        </Button>
                      </li>
                    </>
                  ) : null}
                  </ul>
                </Col>
              </Form>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};
export default Holidays;
